// @flow
export const PRODUCTS_HEATING_HISTORY = 'PRODUCTS_HEATING_HISTORY';
export const PRODUCTS_HEATING_HISTORY_FETCHING = 'PRODUCTS_HEATING_HISTORY_FETCHING';
export const PRODUCTS_SUCCESS = 'PRODUCTS_SUCCESS';
export const PRODUCTS_HEATING_HISTORY_ERROR = 'PRODUCTS_HEATING_HISTORY_ERROR';
export const PRODUCTS_PATH = 'products';
export const LEAK_STATUS_NONE = 'NONE';
export const LEAK_STATUS_LOW = 'LOW';
export const LEAK_STATUS_HIGH = 'HIGH';

export type LeakStatusTypes = typeof LEAK_STATUS_NONE | typeof LEAK_STATUS_HIGH | typeof LEAK_STATUS_HIGH;



// WEBPACK FOOTER //
// ./src/core/constants/products.js